import React, { Component } from "react";
import Popup from "./Popup";
import Strings from "@my-dld/assets/strings";

interface Props {
	message: string;
	actionLabel?: string;
	onAction: () => void;
	onCancel: () => void;
}

class MessageActionButtonPopup extends Component<Props> {
	render() {
		const { message, actionLabel } = this.props;
		return (
			<Popup
				autoOpenMount={ true } id={ "message_action" } onDismiss={ () => {
				this.props.onCancel();
			} }>
				<div className="modal-body">
					<div className="text-center" id="exampleModalLabel">{ message }</div>
				</div>
				<div className="modal-footer row pb-0 d-flex justify-content-center">
					<button
						type="button" className="btn btn_1 btn_style1" onClick={ () => {
						this.props.onAction();
					} }>{ actionLabel ? actionLabel : Strings.ok }</button>
				</div>
			</Popup>
		);
	}
}

export default MessageActionButtonPopup;
